// Mock data store for contact form submissions
// This stores in browser localStorage until backend is integrated

const STORAGE_KEY = 'cedarandash_contact_submissions';

export const getSubmissions = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
};

export const saveSubmission = (submission) => {
  const submissions = getSubmissions();
  const newSubmission = {
    id: Date.now().toString(),
    ...submission,
    createdAt: new Date().toISOString(),
  };
  submissions.push(newSubmission);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(submissions));
  return newSubmission;
};

export const supportInfo = {
  email: 'support@cedarandash.com',
  emailHours: '24/7',
  phone: '(830) 227-2574',
  phoneHours: 'Mon\u2013Fri, 9 AM\u20135 PM (EST)',
};
